import React from 'react';
import {RemoveRedEye as RemoveRedEyeIcon} from '@material-ui/icons';

export const RemoveRedEye = () => {
  return <RemoveRedEyeIcon />;
};
